import type { CaseStudy } from "./types";

const cs: CaseStudy = {
  slug: "dakar-gtm",
  founder: "Mamadou Diallo",
  company: "Senlogi",
  city: "Lomé",
  country: "Togo",
  pillar: "coaching",
  outcomeShort: {
    en: "Closed 3 enterprise deals in 60 days",
    fr: "3 contrats grands comptes signés en 60 jours",
  },
  title: {
    en: "A Lomé B2B founder lands 3 enterprise contracts in 60 days",
    fr: "Un fondateur B2B à Lomé décroche 3 contrats entreprise en 60 jours",
  },
  subtitle: {
    en: "Outbound restructured around real West African buying cycles.",
    fr: "Outbound reconstruit autour des vrais cycles d'achat ouest-africains.",
  },
  body: {
    en: {
      context: "Mamadou's logistics SaaS had pilots stuck in 'evaluation' for over a year. The pipeline looked busy but nothing closed.",
      challenge: "Enterprise procurement in Francophone West Africa runs on relationships and ministry calendars — not on demo-to-trial-to-close funnels.",
      approach: "8 weeks of 1:1 coaching: rebuilt the pitch around concrete ROI per truck, rewrote MSAs in French + English, and mapped the 4 real decision-makers per account.",
      outcome: "Closed Togocom, CFAO Togo, and a Ministry of Commerce pilot. Average sales cycle dropped from 11 to 6 months.",
      quote: "I was selling like a Silicon Valley founder in a market that doesn't work that way. The coach helped me sell like a Lomé founder.",
      quoteAuthor: "Mamadou Diallo · Founder, Senlogi",
    },
    fr: {
      context: "Le SaaS logistique de Mamadou avait des pilotes bloqués en 'évaluation' depuis plus d'un an. Le pipeline semblait actif mais rien ne se concluait.",
      challenge: "Les achats entreprise en Afrique de l'Ouest francophone fonctionnent à la relation et au calendrier ministériel — pas via des funnels demo-trial-close.",
      approach: "8 semaines de coaching 1:1 : pitch reconstruit autour du ROI concret par camion, MSA réécrits en FR + EN, et cartographie des 4 vrais décideurs par compte.",
      outcome: "Togocom, CFAO Togo et un pilote ministère du Commerce signés. Cycle de vente moyen passé de 11 à 6 mois.",
      quote: "Je vendais comme un fondateur de la Silicon Valley dans un marché qui ne fonctionne pas comme ça. Le coach m'a aidé à vendre comme un fondateur loméen.",
      quoteAuthor: "Mamadou Diallo · Fondateur, Senlogi",
    },
  },
};
export default cs;
